export const NETWORK_ERROR_MESSAGES = new Set([
  // Chrome & Edge
  'Failed to fetch',
  // Firefox
  'NetworkError when attempting to fetch resource.',
  // Safari
  'cancelled',
  'annulé',
  'Abgebrochen',
  'Load failed',
  'La requête a expiré.',
  'La connexion Internet semble interrompue.',
  'La connexion réseau a été perdue.',
]);

function hasStatusZero(value: unknown): boolean {
  return Boolean(value && typeof value === 'object' && 'status' in value && value.status === 0);
}

/**
 * If a network request fails due to network issues then this function will return `true`.
 */
export function isNetworkError(error: unknown): boolean {
  return (
    (error instanceof TypeError && NETWORK_ERROR_MESSAGES.has(error.message)) ||
    (error instanceof DOMException && error.name === 'NetworkError') ||
    hasStatusZero(error) ||
    Boolean(
      error && typeof error === 'object' && 'request' in error && hasStatusZero(error.request)
    )
  );
}
